import type { IPersonalData } from 'AppRoutes/context/SubscriptionContext';

export const getDestinationPostalCode = (
  personalData: IPersonalData | undefined,
): string => {
  const cep = personalData?.cep || personalData?.address?.zip || '';
  return cep.replace(/\D/g, '');
};

export const getDestinationCity = (
  personalData: IPersonalData | undefined,
): string =>
  (personalData?.address?.city || personalData?.city || '').trim();

export const getDestinationUf = (
  personalData: IPersonalData | undefined,
): string =>
  (personalData?.address?.uf || personalData?.uf || '').trim().toUpperCase();

export const isAraraquaraAddress = (
  personalData: IPersonalData | undefined,
): boolean => {
  const city = getDestinationCity(personalData);
  const uf = getDestinationUf(personalData);

  return (
    city.localeCompare('Araraquara', 'pt-BR', { sensitivity: 'base' }) === 0 &&
    uf === 'SP'
  );
};
